import React, { Component } from "react";
import { useNavigate } from 'react-router-dom';
import Layout from "../../../common/Layout";
import PropTypes from "prop-types";
// import { Query } from "@apollo/client/react/components"; // TODO: Replaced with REST hook
// import { client } from "../../../settings/apollo"; // TODO: Replaced with REST hook
import AddItemButton from "../../../common/components/base/AddItemButton";
// import { getChallenge} from "./services" // TODO: Replaced with REST hook
import ItemsGrid from "../../../common/components/widgets/ItemsGrid";
import {downloadJson} from './../../../common/components/base/JsonDownload'
import UploadDialog from "./uploadDialog";
import { useChallenge } from '../../../hooks/useChallenge';
import { useDeleteChallenge } from '../../../hooks/useDeleteChallenge';
// import gql from "graphql-tag"; // TODO: Replaced with REST hook
import Swal from 'sweetalert2';
import LoadingSpinner from "../../../common/components/LoadingSpinner/LoadingSpinner";
import { useResultsChallenges } from '../../../hooks/useResultsChallenges';
import SimpleSearch from '../../../common/components/data-table/SimpleSearch';

const columns = ["challengeName", "challengeTitle","isDraft", "action"];
const columnsName = ["name", "title", "Status", "action" ]

// TODO: Replaced GraphQL mutation with REST hook
/*
const DELETE_CHALLENGE_DEFINITION= gql`
mutation deleteChallengeDefinition($id: Int!) {
  deleteChallengeDefinition(id: $id)
}
`;
*/

// Wrapper component for challenge download using REST hook
const ChallengeDownloadWrapper = ({ challengeId, onDownloadComplete }) => {
  const { data: challengeData, isLoading, error } = useChallenge(challengeId);

  React.useEffect(() => {
    if (challengeData && !isLoading && challengeId) {
      // Parse the challenge data and trigger download
      const parsedData = typeof challengeData === 'string' ? JSON.parse(challengeData.challengeDefinition) : challengeData.challengeDefinition;
      downloadJson(parsedData, `challenge${challengeId}`);
      onDownloadComplete();
    }
  }, [challengeData, isLoading, challengeId, onDownloadComplete]);

  if (isLoading) return <div>Preparing download...</div>;
  if (error) return <div>Error preparing download: {error.message}</div>;
  
  return null;
};

// Wrapper component to use hooks with class component
const ChallengeDefinitionsWrapper = ({ name, component }) => {
  const { data: challengeData, isFetching: isLoading, error, refetch } = useResultsChallenges(name);
  const deleteChallengeMutation = useDeleteChallenge();

  // Pass data to class component
  React.useEffect(() => {
    if (challengeData?.challengeDefinitionNames) {
      const sortedChallengeDefinitions = [...challengeData.challengeDefinitionNames]
        .map(challenge => ({
          ...challenge,
          isDraft: challenge.isDraft ? 'Draft' : 'Published'
        }));
      component.setState({ challengesToDo: sortedChallengeDefinitions });
    }
  }, [challengeData, component]);

  // Pass refetch function to component
  component.refetchChallenges = refetch;
  
  // Pass delete mutation to component
  component.deleteChallengeMutation = deleteChallengeMutation;

  if (isLoading) return <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />;
  if (error) return `Error! ${error.message}`;
  if (!challengeData?.challengeDefinitionNames) return <div>No Challenges available</div>;

  return (
    <div>
      <ItemsGrid
        columns={columns}
        download={(index, value) => component._download(value)}
        upload={(index, value) => component.setState({ uploadDialog: true, uploadItem: value })}
        edit={(index, value) => component._edit(index, value)}
        columnsName={columnsName}
        remove={(index, value) => component._remove(value)}
        title="Challenges"
        items={component.state.challengesToDo}
        pagination={true}
        rowsPerPage={20}
      />
      <UploadDialog
        title={component.state.uploadItem ? "Update Challenge" : "Upload Challenge"}
        handleUndo={() => component.setState({ uploadDialog: false, uploadItem: null })}
        handleClose={() => component.setState({ uploadDialog: false, uploadItem: null })}
        uploadItem={component.state.uploadItem}
        open={component.state.uploadDialog}
        saveName="Save"
        button={true}
      >
        {component.state.uploadItem ?
          "Select .json challenge file  to replace current challenge"
          :
          "Select .json challenge file  to insert new challenge"
        }
      </UploadDialog>
      
      {/* Challenge download wrapper - only renders when downloadingChallengeId is set */}
      {component.state.downloadingChallengeId && (
        <ChallengeDownloadWrapper
          challengeId={component.state.downloadingChallengeId}
          onDownloadComplete={() => component.setState({ downloadingChallengeId: null })}
        />
      )}
    </div>
  );
};

class ChallengesList extends Component {
  static propTypes = {
    page: PropTypes.number,
    name: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      name: "",
      uploadDialog: false,
      uploadItem:'',
      challengesToDo:[],
      downloadData:[],
      downloadingChallengeId: null // For REST hook download
    };
    this._add = this._add.bind(this);
    this._download = this._download.bind(this);
    this._remove = this._remove.bind(this);
    this._edit = this._edit.bind(this);
    this._keyPress = this._keyPress.bind(this);
    this.removeChallenge=this.removeChallenge.bind(this);
  }

  // TODO: Replaced with REST hook wrapper
  // async componentDidMount() {
  //   getChallengeDefinitions(client).then(async (value) => {
  //     const clonedValue=[...value];
  //     const sortedChallengeDefinitions=clonedValue.sort((a, b) => a.challengeName > b.challengeName ? 1 : -1);
  //     this.setState({challengesToDo: sortedChallengeDefinitions})
  //   }).catch((e)=> console.log(e))
  // }

  _add() {
    // Navigate to challenge creation page instead of opening dialog
    this.props.navigate('/challenge-creation/new');
  }

  _keyPress(e) {
    if (e.keyCode === 13) {
      this.setState({
        name: e.target.value,
        page: 0
      });
    }
  }

  _download(item) {
    // Use REST hook to download challenge
    this.setState({ downloadingChallengeId: item.id });
  }

  _edit(index, item) {
    // Navigate to challenge edit page
    this.props.navigate(`/challenge-creation/edit/${item.id}`);
  }
  
  removeChallenge(id){
    const index= this.state.challengesToDo.findIndex(function(item) {
      return (item.id === id);
    });
    const clonedChallenges=[...this.state.challengesToDo];
    clonedChallenges.splice(index,1);
                 // .sort((a, b) => a.challengeName > b.challengeName ? 1 : -1);
    this.setState({challengesToDo: clonedChallenges})
  }

   _remove(item) {
    Swal.fire({
      title: 'Are you sure you want to delete this challenge?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      }
    }).then((result) => {
      if (result.value === true) {
        // Use REST API mutation instead of GraphQL
        this.deleteChallengeMutation.mutate(item.id, {
          onSuccess: () => {
            this.removeChallenge(item.id);
            Swal.fire('Challenge deleted!', '', 'success');
            // Data will be automatically refetched due to query invalidation in the hook
          },
          onError: (error) => {
            console.error('Error deleting challenge:', error);
            Swal.fire('Error!', 'Failed to delete challenge. Please try again.', 'error');
          }
        });
      }
    })
  }

  render() {
    return (
      <Layout name="Challenges List">
        <div className="wizard-container">
          <AddItemButton OnClick={this._add} disabled={this.state.uploadDialog} />    
          <div className="row justify-content-end">
            <div className="col-xl-2 col-lg-6">
              <SimpleSearch keyPress={this._keyPress} />
            </div>
          </div>
          <ChallengeDefinitionsWrapper name={this.state.name} component={this} />
        </div>
      </Layout>
    );
  }
}

// Wrapper to provide navigate to class component
const ChallengesListWithNavigate = (props) => {
  const navigate = useNavigate();
  return <ChallengesList {...props} navigate={navigate} />;
};

export default ChallengesListWithNavigate;
